import React from 'react';

import { Flex } from '@chakra-ui/react';

function Mentions() {
  return <Flex data-id="bf23c9269eed">Mentions</Flex>
}

export default Mentions;
